import { Box, Button, Dialog, DialogContent, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import NumberFormat from 'react-number-format';
import { convertCentsToDollars } from '../../util/converters';
import WhiteInosio from "../../../icons/whiteinosio.svg";
import { PaymentRequestBalanceDto } from "@inosio/payments-sdk";
import BackIcon from '../../../icons/back1.svg'
import close from '../../../icons/close.svg'
import moment from 'moment';
import { makeStyles } from "@mui/styles"
import DialogTermsAndConditions from '../../../resui/payments/components/DialogTermsAndConditions';
import { useDispatch, useSelector } from "react-redux";
import { selectPaymentRequestsState, setMakePaymentRequestOtpErrorClear } from '../../../pmui/paymentrequests/sagas/paymentrequestslice';


interface ReviewAndSubmitModalProps {
    open: boolean;
    onCloseIcon: () => void;
    onBackClick: () => void;
    onConfirm: () => void;
    PaymentRequestDetails: PaymentRequestBalanceDto | null;
    FeeAmount: number;
}

const ReviewAndSubmitModal = (props: ReviewAndSubmitModalProps) => {
    const { open, onCloseIcon, onBackClick, onConfirm, PaymentRequestDetails, FeeAmount } = props;
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const [openLegaleseDialog, setOpenLegaleseDialog] = React.useState(false);
    const [openFeesDialog, setOpenFeesDialog] = React.useState(false);
    const { errorPaymentRequestOtp } = useSelector(selectPaymentRequestsState);
    const handleCloseLegaleseDialog = () => setOpenLegaleseDialog(false);
    const handleCloseFeesDialog = () => setOpenFeesDialog(false);
    const handleLegaleseClick = () => setOpenLegaleseDialog(true);
    const handleFeesClick = () => setOpenFeesDialog(true);

    const dispatch = useDispatch();

    const onClickOfCloseIcon = () => {
        onCloseIcon()
        dispatch({
            type: setMakePaymentRequestOtpErrorClear.type
        })
    }

    const style = {
        height: isOnMobileScreen ? "100%" : "523px"
    };

    const useStyles = makeStyles({
        termsAndConditionLink: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#39A2DB !important",
            marginTop: "18px",
            cursor: "pointer",
        },
    })

    const classes = useStyles();


    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: 'hidden'
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column">
                            {isOnMobileScreen ?
                                <Grid item display='flex' justifyContent='center'>
                                    <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                        <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                        <Typography
                                            sx={{
                                                fontFamily: "Work Sans",
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '18px',
                                                lineHeight: '23px',
                                                color: '#14142B',
                                                textAlign: 'left',
                                                padding: '15px'
                                            }}>
                                            {PaymentRequestDetails?.CompanyName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                : <></>}
                            <Grid item display='flex' justifyContent='center'>
                                <Typography id='reviewAndSubmit'
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '18px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginTop: '30px'
                                    }}>
                                    Review & Submit
                                </Typography>
                            </Grid>
                            <Grid item >
                                <Typography
                                    style={{
                                        fontFamily: "'Open Sans', sans-serif",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        lineHeight: "18px",
                                        color: "#DB3939",
                                        textAlign: "center",
                                        borderTop: errorPaymentRequestOtp?.message?.length ? "2px  solid #DB3939" : '',
                                        borderRadius: "24px",
                                        padding: "12px 20px",
                                        width: isOnMobileScreen ? '240px' : "340px",
                                        margin: "0px auto",
                                    }}
                                >
                                    {errorPaymentRequestOtp?.message}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent={'space-between'}>
                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                    fontFamily: "Work Sans",
                                }}>
                                    {PaymentRequestDetails?.CompanyName}
                                </Typography>

                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                    fontFamily: "Work Sans",
                                }}>
                                    {PaymentRequestDetails?.CompanyName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} display='flex' justifyContent={'space-between'}>
                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                    fontFamily: "Work Sans",
                                }}>
                                    {PaymentRequestDetails?.PayerName}
                                </Typography>

                                <Typography sx={{
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "22px",
                                    fontFamily: "Work Sans",
                                }}>
                                    {`Due: ${moment(PaymentRequestDetails?.DueDate).format("MM/DD/YYYY")}`}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} mt={2} sx={{
                                maxHeight: errorPaymentRequestOtp?.message?.length > 0 ? '150px' : '200px',
                                overflow: 'auto',
                                "&::-webkit-scrollbar": {
                                    width: 7,
                                },
                                "&::-webkit-scrollbar-track": {
                                    boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                                    borderRadius: '24px',
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "darkgrey",
                                    borderRadius: '24px',
                                }
                            }}>
                                {
                                    PaymentRequestDetails?.RequestDetails?.map((req, index) => {
                                        return (
                                            <Grid item xs={12} key={index}>
                                                <Grid item xs={12} display='flex' justifyContent={'space-between'} ml={1} mr={2}>
                                                    <Grid item xs={9.5}>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 600,
                                                                fontSize: "16px",
                                                                lineHeight: "22px",
                                                                fontFamily: "Work Sans",
                                                                color: '#D3D3D3'
                                                            }}>
                                                            {req.Description}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2.5}>
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "22px",
                                                                fontFamily: "Work Sans",
                                                                color: '#D3D3D3'
                                                            }}>
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={convertCentsToDollars(req.Amount)}
                                                                prefix="$"
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} mt={1} mb={1} mr={1}>
                                                    {<Divider sx={{ width: '100%' }} />}
                                                </Grid>
                                            </Grid>
                                        )
                                    })
                                }
                                <Grid item xs={12} display='flex' justifyContent={'space-between'} ml={1} mr={2}>
                                    <Grid item xs={9.5}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "16px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                                color: '#D3D3D3'
                                            }}>
                                            Fee
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "16px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                                color: '#D3D3D3'
                                            }}>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={convertCentsToDollars(FeeAmount)}
                                                prefix="$"
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sx={{ position: 'relative', width: '100%' }} >
                                <Divider />
                                <Grid container justifyContent={'space-between'} >
                                    <Grid item pt={2} pb={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                            }}>
                                            Total
                                        </Typography>
                                    </Grid>
                                    <Grid item pt={2}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "18px",
                                                lineHeight: "22px",
                                                fontFamily: "Work Sans",
                                            }}>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={convertCentsToDollars(PaymentRequestDetails?.Amount ? PaymentRequestDetails?.Amount + FeeAmount : 0)}
                                                prefix="$"
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </Typography>
                                    </Grid>
                                    <div>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition" sx={{
                                        }}>
                                            By clicking submit you agree to our{" "}
                                            <span className={classes.termsAndConditionLink}
                                                onClick={() => {
                                                    window.open("/terms");
                                                }}
                                            >
                                                {"T&Cs..."}
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition" >
                                            Fraudulent Payment will be prosecuted to{" "}
                                            <span className={classes.termsAndConditionLink} onClick={handleLegaleseClick}>
                                                the fullest extent…
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" gutterBottom id="terms-and-condition">
                                            Payments resulting in returns or chargebacks may incur{" "}
                                            <span className={classes.termsAndConditionLink} onClick={handleFeesClick}>
                                                additional fees.
                                            </span>
                                        </Typography>
                                        <DialogTermsAndConditions openState={openLegaleseDialog} handleClose={handleCloseLegaleseDialog} default={true} />
                                        <DialogTermsAndConditions openState={openFeesDialog} handleClose={handleCloseFeesDialog} default={false} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item display={'flex'} flexDirection={isOnMobileScreen ? 'column' : 'row'} justifyContent={'flex-end'} >
                            <Grid item xs={12} pb={isOnMobileScreen ? 10 : 0}>
                                <Button id='reviewAndSubmitOnConfirmBtn'
                                    variant="contained"
                                    style={{
                                        borderRadius: "24px",
                                        textTransform: "capitalize",
                                        color: "white",
                                        backgroundColor: "#39A2DB",
                                        borderColor: "#39A2DB",
                                        height: '49',
                                        width: isOnMobileScreen ? '100%' : '140px'
                                    }}
                                    onClick={onConfirm}
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>
                {
                    isOnMobileScreen ? <Grid item sx={{ position: 'absolute', top: 125, left: 15 }}>
                        <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={onBackClick} />
                    </Grid>
                        : <><Grid item sx={{ position: 'absolute', top: 48, left: 15 }}>
                            <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={onBackClick} />
                        </Grid><Grid item sx={{ position: 'absolute', top: 47, right: 18 }}>
                                <img src={close} alt="back" style={{ cursor: 'pointer' }} onClick={onClickOfCloseIcon} />
                            </Grid></>
                }
                <DialogTermsAndConditions openState={openLegaleseDialog} handleClose={handleCloseLegaleseDialog} default={true} />
                <DialogTermsAndConditions openState={openFeesDialog} handleClose={handleCloseFeesDialog} default={false} />
            </DialogContent>
        </Dialog>


    );

}
export default ReviewAndSubmitModal;
